import type { JSX } from 'react';

import { animatePulseStyles } from '@change-corgi/design-system-legacy/animations';
import { Box } from '@change-corgi/design-system-legacy/layout';

export function LoadingSkeleton(): JSX.Element {
	return (
		<Box
			data-testid="media-hits-loading"
			sx={{
				background: 'primary-greyBackground',
				borderRadius: 'standard',
				height: '150px',
				width: '100%',
				...animatePulseStyles(500),
			}}
			my={16}
		></Box>
	);
}
